import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarAlunoApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/student/createStudent`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarAlunoApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/student/getStudents`, body, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarAlunoApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/student/getStudentsByID`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarAlunoPorResponsavelApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/student/getStudentsByResponsible`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarAlunoApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/student/updateStudent`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirAlunoApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/student/deleteStudent`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}